/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_AwesomeInputs */

const en_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awesome`)
};

const ar_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدهش`)
};

const de_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toll`)
};

const es_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Genial!`)
};

const fr_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génial`)
};

const it_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splendido`)
};

const ja_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素晴らしい`)
};

const ko_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대단해요`)
};

const pt_br_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrível`)
};

const ru_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Супер`)
};

const th_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สุดยอด`)
};

const tr_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harika`)
};

const zh_cn_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了`)
};

const zh_tw_btn_awesome = /** @type {(inputs: Btn_AwesomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了`)
};

/**
* | output |
* | --- |
* | "Awesome" |
*
* @param {Btn_AwesomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_awesome = /** @type {((inputs?: Btn_AwesomeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_AwesomeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_awesome(inputs)
	if (locale === "ar") return ar_btn_awesome(inputs)
	if (locale === "de") return de_btn_awesome(inputs)
	if (locale === "es") return es_btn_awesome(inputs)
	if (locale === "fr") return fr_btn_awesome(inputs)
	if (locale === "it") return it_btn_awesome(inputs)
	if (locale === "ja") return ja_btn_awesome(inputs)
	if (locale === "ko") return ko_btn_awesome(inputs)
	if (locale === "pt_br") return pt_br_btn_awesome(inputs)
	if (locale === "ru") return ru_btn_awesome(inputs)
	if (locale === "th") return th_btn_awesome(inputs)
	if (locale === "tr") return tr_btn_awesome(inputs)
	if (locale === "zh_cn") return zh_cn_btn_awesome(inputs)
	return zh_tw_btn_awesome(inputs)
});